const errorCodesMap = [
  "571115",
  "571116",
  "571118",
  "571120",
  "571121",
  "571122",
  "571123",
  "571124",
  "571125",
  "571126",
  "571127",
  "571128",
  "571129",
  "571130",
  "571131",
  "571132",
  "571133",
  "571134",
  "571135",
  "571136",
  "571137",
  "571140",
  "571141",
  "571142",
  "571143",
  "571144",
  "571145",
  "571199"
]; // error codes

let errorCodes = [];

export function createErrorMapper() {
  let i;
  let item = {};
  for (i = 1000; i <= 1099; i++) {
    //general Default Errors

    item["code" + i] = errorCodesMap[20];
    errorCodes.push(item);
  }
  for (i = 1100; i <= 1199; i++) {
    //setup  Errors
    if (i === 1103 || i === 1102 || i === 1104) {
      item["code" + i] = errorCodesMap[15]; //no Auth  error
    } else if (i === 1113) {
      item["code" + i] = errorCodesMap[18]; //not supported error
    } else if (i === 1107 || i === 1106) {
      item["code" + i] = errorCodesMap[19]; //security error
    } else {
      item["code" + i] = errorCodesMap[16]; //genaric error
    }
    errorCodes.push(item);
  }
  for (i = 1200; i <= 1299; i++) {
    //source  Errors
    if (i === 1208 || i === 1207 || i === 1202) {
      item["code" + i] = errorCodesMap[3]; //no such file  error
    } else if (i === 1209) {
      item["code" + i] = errorCodesMap[13]; //audio/video not supported error
    } else if (i === 1210 || i === 1204) {
      item["code" + i] = errorCodesMap[18]; //not supported format error
    } else if (i === 1203) {
      item["code" + i] = errorCodesMap[10]; //notsupported file error
    } else if (i === 1201) {
      item["code" + i] = errorCodesMap[11]; //invalid url
    } else {
      item["code" + i] = errorCodesMap[16]; //genaric error
    }
    errorCodes.push(item);
  }
  for (i = 1300; i <= 1399; i++) {
    //playback Errors
    if (i === 1304) {
      item["code" + i] = errorCodesMap[14]; //HLS playback error
    } else if (i === 1301) {
      item["code" + i] = errorCodesMap[14]; //video decoding error
    } else {
      item["code" + i] = errorCodesMap[16]; //genaric error
    }
    errorCodes.push(item);
  }
  for (i = 1400; i <= 1499; i++) {
    //Network Errors
    if (i === 1400) {
      item["code" + i] = errorCodesMap[26]; //network error
    } else if (i === 1401 || i === 1403 || i === 1402 || i === 1404) {
      item["code" + i] = errorCodesMap[20]; //default error
    } else {
      item["code" + i] = errorCodesMap[16]; //genaric error
    }
    errorCodes.push(item);
  }
  for (i = 2000; i <= 2099; i++) {
    //DRM Errors
    item["code" + i] = errorCodesMap[23]; //DRM Default error
    errorCodes.push(item);
  }
}

export function getErrorCode(code) {
  return errorCodes[0]["code" + code];
}
